const VIEWPORT_PADDING = 12;
const TOOLTIP_GAP = 10;
const TOOLTIP_MAX_WIDTH = 320;

/**
 * Computes viewport-safe tooltip placement for compact calculator help bubbles.
 * Returns fixed-position style so the bubble cannot get clipped by parent boxes.
 */
export function computeTooltipPlacement(wrapEl) {
  if (!wrapEl || typeof window === 'undefined') {
    return { tooltipPosClass: '', tooltipInlineStyle: undefined };
  }

  const bubbleEl = wrapEl.querySelector('.nps-ups-tooltip-bubble');
  const wrapRect = wrapEl.getBoundingClientRect();
  const maxWidth = Math.min(
    TOOLTIP_MAX_WIDTH,
    Math.max(180, window.innerWidth - VIEWPORT_PADDING * 2),
  );

  let measuredWidth = maxWidth;
  let measuredHeight = 132;

  if (bubbleEl) {
    const prev = {
      position: bubbleEl.style.position,
      left: bubbleEl.style.left,
      top: bubbleEl.style.top,
      width: bubbleEl.style.width,
      transform: bubbleEl.style.transform,
      visibility: bubbleEl.style.visibility,
      opacity: bubbleEl.style.opacity,
    };

    bubbleEl.style.position = 'fixed';
    bubbleEl.style.left = '-9999px';
    bubbleEl.style.top = '0';
    bubbleEl.style.width = `${maxWidth}px`;
    bubbleEl.style.transform = 'none';
    bubbleEl.style.visibility = 'hidden';
    bubbleEl.style.opacity = '0';

    const rect = bubbleEl.getBoundingClientRect();
    if (rect.width > 0) measuredWidth = rect.width;
    if (rect.height > 0) measuredHeight = rect.height;

    bubbleEl.style.position = prev.position;
    bubbleEl.style.left = prev.left;
    bubbleEl.style.top = prev.top;
    bubbleEl.style.width = prev.width;
    bubbleEl.style.transform = prev.transform;
    bubbleEl.style.visibility = prev.visibility;
    bubbleEl.style.opacity = prev.opacity;
  }

  let left = wrapRect.right + TOOLTIP_GAP;
  let tooltipPosClass = 'nps-ups-tooltip-wrap--right';

  if (left + measuredWidth > window.innerWidth - VIEWPORT_PADDING) {
    left = wrapRect.left - measuredWidth - TOOLTIP_GAP;
    tooltipPosClass = 'nps-ups-tooltip-wrap--left';
  }

  if (left < VIEWPORT_PADDING) {
    left = Math.max(
      VIEWPORT_PADDING,
      Math.min(
        wrapRect.left + wrapRect.width / 2 - measuredWidth / 2,
        window.innerWidth - measuredWidth - VIEWPORT_PADDING,
      ),
    );
  }

  const centeredTop = wrapRect.top + wrapRect.height / 2 - measuredHeight / 2;
  const top = Math.max(
    VIEWPORT_PADDING,
    Math.min(centeredTop, window.innerHeight - measuredHeight - VIEWPORT_PADDING),
  );

  return {
    tooltipPosClass,
    tooltipInlineStyle: {
      position: 'fixed',
      left: `${Math.round(left)}px`,
      top: `${Math.round(top)}px`,
      width: `${Math.round(measuredWidth)}px`,
      maxWidth: `calc(100vw - ${VIEWPORT_PADDING * 2}px)`,
    },
  };
}
